import PropTypes from 'prop-types';
import React, { Component } from 'react';


class CounterView extends Component {

  render() {
    const { increase, decrease, value } = this.props;
    return (
      <span className="counter">
        <button className="counter__button" onClick={decrease}>-</button>
        <span className="counter__value">{value}</span>
        <button className="counter__button" onClick={increase}>+</button>
      </span>
    )
  }
}

CounterView.propTypes = {
  value: PropTypes.number.isRequired,
  increase: PropTypes.func.isRequired,
  decrease: PropTypes.func.isRequired,
};

export default CounterView;


// WEBPACK FOOTER //
// ./src/components/Counter/CounterView.js